import { KYMW0D00Model } from './../kymw0d00.model';
import { PlessResponderSub } from './../../../kymw00/pless-responder-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 処理ログ 処理結果データ出力クラス
 *
 * @export MakeLogDataService
 * @class MakeLogDataService
 * @extends PlessJsonResponderSub
 */
@Injectable()
export class MakeLogDataService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW0D00Model;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof MakeLogDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        LogHeader: {
          condition: {
            InfoKind: this.vo.headerInfoKind,
            LineNo: this.vo.headerLineNo,
            DataKind: this.vo.headerDataKind,
            ProcessResult: this.vo.headerProcessResult,
            Contents: this.vo.headerContents,
            DispId: this.vo.dispId
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof MakeLogDataService
   */
  execute(model: KYMW0D00Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('makeLogData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof MakeLogDataService
   */
  success(data: any): void {
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
